import CustomBpmnRules from "./customBpmnRules";
import CustomCommandInterceptor from "./customCommandInterceptor";
import CustomContextPad from "./customContextPad";
import CustomReplaceMenu from "./customReplaceMenu";
import HappyPathPhaseInterceptor from "./happyPathPhaseInterceptor";

// NOTE: no palette provider is registered — the stock .djs-palette is hidden (general.scss) and
// element creation lives in the Kuika category-rail palette (flows/diagram-palette.tsx).
export default (sdContextInstance) => ({
  __depends__: ["popupMenu", "bpmnReplace", "modeling", "styles"],
  __init__: [
    "providerInstance",
    "customContextPad",
    "customReplaceMenu",
    "customBpmnRules",
    "customCommandInterceptor",
    "happyPathPhaseInterceptor"
  ],
  customContextPad: ["type", CustomContextPad],
  customReplaceMenu: ["type", CustomReplaceMenu],
  customBpmnRules: ["type", CustomBpmnRules],
  customCommandInterceptor: ["type", CustomCommandInterceptor],
  happyPathPhaseInterceptor: ["type", HappyPathPhaseInterceptor],
  providerInstance: ["value", sdContextInstance]
});
